exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "svg{flex-shrink:0}.block svg{display:block}\n", ""]);
